"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roomFilter = void 0;
const roomFilter = (availablePeriods, roomAvailablePeriods, lengthMin) => {
    const roomsAvailablePeriods = Object.values(roomAvailablePeriods);
    const roomsOrAvailablePeriods = roomsAvailablePeriods.reduce((acc, currentValue) => acc.or(currentValue, lengthMin));
    return availablePeriods.and(roomsOrAvailablePeriods);
};
exports.roomFilter = roomFilter;
//# sourceMappingURL=roomFilter.js.map